import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BG6MEPCE.js";

// src/link.tsx
import Original from "next/link";
import { jsx } from "react/jsx-runtime";
function Link(_a) {
  var _b = _a, {
    href = "/",
    external = !(href.startsWith("/") || href.startsWith("#") || href.startsWith("."))
  } = _b, props = __objRest(_b, [
    "href",
    "external"
  ]);
  if (external) {
    return /* @__PURE__ */ jsx("a", __spreadProps(__spreadValues({ href, rel: "noreferrer noopener", target: "_blank" }, props), { children: props.children }));
  }
  return /* @__PURE__ */ jsx(Original, __spreadValues({ href }, props));
}

export {
  Link
};
